import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import SkipToMapLink from './SkipToMapLink.js';

const SkipToMapLinkContainer = (_param)=>{
    var { mapId  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "mapId"
    ]);
    const { getLabel  } = useIntl();
    // We cannot create a ref for the tabindex div that needs to be focused because it is generated
    // from the GoogleMaps library. Therefore, focus is managed here with vanilla js instead.
    const onClick = (event)=>{
        var ref, ref1;
        event.preventDefault();
        (ref1 = (ref = document.getElementById(mapId)) === null || ref === void 0 ? void 0 : ref.querySelector('[tabindex="0"]')) === null || ref1 === void 0 ? void 0 : ref1.focus();
    };
    return /*#__PURE__*/ React.createElement(SkipToMapLink, swcHelpers.extends({}, rest, {
        href: `#${mapId}`,
        onClick: onClick,
        text: getLabel('stores.page.search.skipToMapLink')
    }));
};

export { SkipToMapLinkContainer as default };
//# sourceMappingURL=SkipToMapLinkContainer.js.map
